import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

const Home = React.lazy(() => import("./pages/Home"));
const Menu = React.lazy(() => import("./pages/Menu"));
const Catering = React.lazy(() => import("./pages/Catering"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Page404 = React.lazy(() => import("./pages/404"));

function Routes() {
  return (
    <Switch>
      <Route path="/" component={Home} exact />
      <Redirect from="/home" to="/" />
      <Route path="/menu" component={Menu} exact />
      <Route path="/catering" component={Catering} exact />
      <Route path="/contact" component={Contact} exact />
      <Route path="/404" component={Page404} exact status={404} />
      <Redirect from="*" to="/404" />
    </Switch>
  );
}

export default Routes;
